import React from "react";
import { useSelector } from "react-redux";
import { Container } from "./DetectionPreviewStyles";
import Grid from "./DetectionPreviewGrid/Grid";
import ColdStartPreview from "./DetectionPreviewColdStart/ColdStartPreview";
import MainChartContainer from "./DetectionPreviewChart/MainChartContainer";


export default function DetectionPreview() {
  const display = useSelector(({ display }) => display.display);
  return (
    <Container>
      {
        {
          chart: <MainChartContainer show={true} />,
          grid: <Grid />,
          coldStart: <ColdStartPreview />,
          heatMap: <ColdStartPreview />,
        }[display]
      }
    </Container>
  );
}
